import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }

  const hasUpperCase = /[A-Z]/.test(control.value);
  const hasLowerCase = /[a-z]/.test(control.value);
  const hasNumber = /\d/.test(control.value);
  const hasSpecialChar = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(control.value);
  const isValid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && control.value.length >= 8;

  if (!isValid) {
    return { passwordInvalid: true }; // Directly return the validation error object
  }

  return null; // No error if the password is valid
};
